export { StoreImageSpot as default } from './StoreImageSpot';
